import apiClient from "./apiClient";
import {
  BackendLlmUsageDashboardResponse,
  LlmUsageQueryParams,
  LlmUsageExportParams,
} from "../types/llm-usage.types";

/**
 * Fetch LLM Usage Dashboard data
 * Returns raw backend format - transformation happens in useLlmUsageDashboard hook
 */
export const getLlmUsageDashboard = async (
  params?: LlmUsageQueryParams
): Promise<BackendLlmUsageDashboardResponse> => {
  const searchParams = new URLSearchParams();
  if (params?.startDate) searchParams.append("startDate", params.startDate);
  if (params?.endDate) searchParams.append("endDate", params.endDate);

  const queryString = searchParams.toString();
  const url = `/grants/admin/llm-usage${queryString ? `?${queryString}` : ""}`;

  const { data } = await apiClient.get<BackendLlmUsageDashboardResponse>(url);
  return data;
};

/**
 * Export LLM Usage data as CSV
 * Returns a Blob for download
 */
export const exportLlmUsageCsv = async (
  params: LlmUsageExportParams
): Promise<Blob> => {
  const searchParams = new URLSearchParams();
  searchParams.append("startDate", params.startDate);
  searchParams.append("endDate", params.endDate);

  const { data } = await apiClient.get(
    `/grants/admin/llm-usage/export?${searchParams.toString()}`,
    {
      responseType: "blob",
    }
  );

  return data;
};

/**
 * Download helper - triggers browser download
 */
export const downloadCsvBlob = (blob: Blob, filename: string): void => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

/**
 * Generate CSV filename based on date range
 */
export const generateCsvFilename = (startDate: string, endDate: string): string => {
  const start = startDate.split("T")[0];
  const end = endDate.split("T")[0];
  return `llm-usage-${start}-${end}.csv`;
};
